import React from 'react';
import {useIntl} from 'react-intl';
import {useDispatch} from 'react-redux';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import * as actions from '../../_redux/invoicesActions';
import can from '../../../_common/components/Permissions/can';

export function DownloadReceipt({cellContent}) {
  const intl = useIntl();
  const dispatch = useDispatch();
  const isEnabled = can('full', 'invoices') && cellContent?.receipts?.some(Boolean);
  const buttonClassName = `w-100 px-4 py-2 d-flex align-items-center justify-content-between text-nowrap font-size-lg 
  ${isEnabled ? `` : `opacity-30`}`;
  const buttonLabel = intl.formatMessage({
    id: 'invoices-button-downloadReceipt',
    defaultMessage: 'Download receipt',
  });

  return (
    <div
      className={buttonClassName}
      onClick={() => {
        if (isEnabled) {
          dispatch(actions.downloadInvoiceReceipts({
            invoiceID: cellContent._id,
            receiptArray: Array.isArray(cellContent?.receipts)
              ? cellContent.receipts.filter(Boolean)
              : [],
            name: cellContent._id
          }))
        }
      }}
    >
      {buttonLabel}
      <img
        src={toAbsoluteUrl('/media/svg/Download_brandColor.svg')}
        alt="icon"
        className={'w-30px h-30px ml-2'}
      />
    </div>
  )
}

export default DownloadReceipt;
